module.exports = __webpack_public_path__ + "static/media/signup-page-freelancer-1.9a740872.webp";